import React from 'react';
import { Box, Icon, IconButton, Paper, Typography } from '@material-ui/core';

export default function NodeGroupCard({ index, label, onRemove, canRemove, children }) {
    return (
        <Paper
            key={`node-${index}`}
            elevation={2}
            style={{
                padding: '16px',
                marginBottom: '16px',
                borderLeft: '4px solid #2196F3',
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" style={{ color: '#333', fontWeight: 'bold' }}>
                    {label}
                </Typography>
                <IconButton
                    size="small"
                    color="default"
                    onClick={onRemove}
                    disabled={!canRemove}
                    disableRipple
                    style={{
                        color: !canRemove ? 'rgba(0, 0, 0, 0.26)' : '#9e9e9e',
                        backgroundColor: 'transparent',
                    }}
                    aria-label="remove node group"
                >
                    <Icon>delete</Icon>
                </IconButton>
            </Box>
            {children}
        </Paper>
    );
}
